import { render, staticRenderFns } from "./simpleDiag.vue?vue&type=template&id=1b34cbec&scoped=true&"
import script from "./simpleDiag.vue?vue&type=script&lang=js&"
export * from "./simpleDiag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34cbec",
  null
  
)

export default component.exports